import { Card, FormControl, Grid, Icon, InputLabel, MenuItem, Select } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
// Data
import memoBilansTableData from "./data/memoBilansTableData";
import DataTable from "examples/Tables/DataTable";
import { Box } from "@mui/system";
import MDButton from "components/MDButton";
import * as modalActions from "./modalActionTypes";
import { useLocation, useParams } from "react-router-dom";
import FormAddMemoBilan from "./components/FormAddMemoBilan";
import MemoBilanModal from "./components/MemoBilanModal";
import { useFormik } from "formik/dist";
import * as actionsCompanies from "../../../companies/redux/state/CompaniesAction";
import { useDispatch, useSelector } from "react-redux";
import FormUpdateMemoBilan from "./components/FormUpdateMemoBilan";
import ConfirmDeleteMemoBilan from "./components/ConfirmDeleteMemoBilan";
import styled from "@emotion/styled";
import FormUploadMemoBilan from "./components/FormUploadMemoBilan";

const MemoBilans = ({ companyId, setCompanyId }) => {
  const location = useLocation();
  const [memoBilanId, setMemoBilanId] = useState("");
  const [action, setAction] = useState(modalActions.ADD);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setAction(modalActions.ADD);
    setMemoBilanId("");
    setOpen(true);
  };
  const handleUpload = () => {
    setAction(modalActions.UPLOAD);
    setMemoBilanId("");
    setOpen(true);
  };
  const { columns, rows } = memoBilansTableData(setOpen, setMemoBilanId, setAction, companyId);

  const handleChange = (e) => {
    setCompanyId(e.target.value);
  };

  const companies = useSelector((state) => state?.companies.companies);

  // Responsive Header Inputs styled components
  const HeaderInputs = styled("div")(({ theme }) => ({
    padding: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "column",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "row",
    },
  }));

  const FilterContainer = styled("div")(({ theme }) => ({
    padding: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    [theme.breakpoints.up("md")]: {
      minWidth: 250,
    },
  }));

  const ButtonsContainer = styled("div")(({ theme }) => ({
    padding: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      display: "grid",
      gridGap:".4em"
      // gridAutoFlow: "column",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
      justifyContent: "flex-end",
    },
  }));

  const disabledSelect = location?.state?.id ? true: false;

  return (
    <Box m={2}>
      <HeaderInputs px={1}>
      <Box mr={1} >
          <FilterContainer>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Filtre par entreprise</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="company_filter"
                value={companyId ?? ""}
                label="Filtre par entreprise"
                onChange={handleChange}
                sx={{ height: 40, background: "white" }}
                disabled = {disabledSelect}
              >
                <MenuItem value="">Selectionner une entreprise</MenuItem>
                {companies && companies.data && companies?.data?.map((company) => {
                  return (
                    <MenuItem key={company?.id} value={company?.id}>
                      {/* {company?.raison_social} */}
                      <p>
                        <b>{company?.raison_social}</b> ({company?.country?.name})
                      </p>
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </FilterContainer>
        </Box>
        <ButtonsContainer>
          <Box mr={1}>
            <MDButton fullWidth onClick={handleOpen} variant="contained" size="small" color="info">
              <Icon>add</Icon> Memo Bilan
            </MDButton>
          </Box>
          <Box mr={1}>
            <MDButton fullWidth to="#" variant="contained" size="small" color="success" onClick={handleUpload}>
                Importer <Icon>uploadfile</Icon>
            </MDButton>
          </Box>
        </ButtonsContainer>
      </HeaderInputs>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Memo Bilan
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                {rows && 
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <MemoBilanModal
        title={
          action == modalActions.UPDATE
            ? "Modifier Memo bilan"
            : action == modalActions.DELETE
            ? "Supprimer Memo bilan"
            : "Ajouter nouveau Memo bilan"
        }
        open={open}
        setOpen={setOpen}
      >
        {/* ADD MODAL */}
        {action == modalActions.ADD && (
          <FormAddMemoBilan
            open={open}
            setOpen={setOpen}
            setAction={setAction}
            companyId={companyId}
            setCompanyId={setCompanyId}
          />
        )}
        {/* DELETE MODAL */}
        {action == modalActions.DELETE && (
          <ConfirmDeleteMemoBilan
            setOpen={setOpen}
            memoBilanId={memoBilanId}
            setMemoBilanId={setMemoBilanId}
            setAction={setAction}
            companyId={companyId}
          />
        )}
        {/* UPDATE MODAL */}
        {action == modalActions.UPDATE && (
          <FormUpdateMemoBilan
            setOpen={setOpen}
            memoBilanId={memoBilanId}
            setMemoBilanId={setMemoBilanId}
            setAction={setAction}
            companyId={companyId}
            setCompanyId={setCompanyId}
          />
        )}
        {action == modalActions.UPLOAD && (
          <FormUploadMemoBilan
            setOpen={setOpen}
            memoBilanId={memoBilanId}
            setMemoBilanId={setMemoBilanId}
            setAction={setAction}
            companyId={companyId}
            setCompanyId={setCompanyId}
          />
        )}
      </MemoBilanModal>
    </Box>
  );
};
export default MemoBilans;
